import {
  AllReportYearsBase,
  ReportAPIResponse,
} from 'npo/pages/ReportsBeta/api';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag } from '@fortawesome/pro-solid-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { Report } from 'shared/components/WelcomeBack/utils';
import TrueImpactFoldButton from 'shared/design-system/components/TrueImpactFoldButton';
import styled from 'styled-components';
import TrueImpactTooltip from '../../components/CustomTooltip/TrueImpactTooltip';
import { capitalizeOnlyFirstLetter } from 'shared/utils/stringUtils';
import { ReportVisibility } from 'shared/auth/hooks/useUserActions';

export const getReportVisibilityText = (
  report: Report | ReportAPIResponse | AllReportYearsBase,
): string => {
  return capitalizeOnlyFirstLetter(report.visibility);
};

interface ReportSharingToggleProps {
  visibility: ReportVisibility;
  className?: string;
  tooltip: string | JSX.Element;
  tooltipMaxWidth?: string;
  tooltipMinWidth?: string;
  publicDisabledReason?: string | JSX.Element;
  handleToggle: (visibility: ReportVisibility) => unknown;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  .donor-name-flag {
    color: ${COLORS.critical};
    margin-right: ${SPACERS.small};
    cursor: help;
  }
`;

const ReportSharingToggle: React.FC<ReportSharingToggleProps> = ({
  visibility,
  tooltip,
  tooltipMaxWidth,
  tooltipMinWidth,
  className,
  publicDisabledReason,
  handleToggle,
}) => {
  const publicDisabled = Boolean(publicDisabledReason);
  return (
    <StyledDiv className={className}>
      {publicDisabled && (
        <TrueImpactTooltip
          maxWidth={tooltipMaxWidth}
          minWidth={tooltipMinWidth}
          title={publicDisabledReason}
        >
          <span className="donor-name-flag" aria-label="Public unavailable">
            <FontAwesomeIcon icon={faFlag} />
          </span>
        </TrueImpactTooltip>
      )}
      <TrueImpactTooltip
        maxWidth={tooltipMaxWidth}
        minWidth={tooltipMinWidth}
        title={tooltip}
      >
        <TrueImpactFoldButton
          buttons={[
            {
              text: 'Public',
              value: 'PUBLIC',
              color: 'whiteBase',
              backgroundColor: 'ctaPrimary',
              disabled: publicDisabled,
            },
            {
              text: 'Restricted',
              value: 'RESTRICTED',
              color: 'whiteBase',
              backgroundColor: 'blackBase',
            },
          ]}
          selectedValue={visibility}
          onClick={handleToggle}
        />
      </TrueImpactTooltip>
    </StyledDiv>
  );
};

export default ReportSharingToggle;
